const hasWindow = typeof window !== 'undefined';
export const { INFURA_PROTOCOL } = process.env;
export const { INFURA_API_KEY } = process.env;
export const { INFURA_NETWORK } = hasWindow ? window : process.env;
export const { NETWORK_NUMBER } = hasWindow ? window : process.env;
